export * from './application-area.service';
